// Canonical roster for the Felix Q2 launch. Data lives in roster.json so
// the Express server (ESM JS) can import the exact same list the React app
// uses — no drift between client and server.

import rosterJson from "./roster.json";

export interface Person {
  email: string;
  name: string;
  firstName: string;
  /** Lowercase tokens that should resolve to this person. */
  aliases: string[];
  /** Optional role tag shown in UI. */
  role?: string;
  /** Public URL (under /people/*) for the person's avatar photo. */
  photo?: string;
}

export const ROSTER: Person[] = rosterJson as Person[];
